module.exports = __webpack_public_path__ + "img/KY.e6b544c0.png";